export const permissions = [
  'All Appointment',
  'Users',
  'Doctors',
  'Patients',
  'Coupons',
  'Live Appointment',
  'Payment General',
  'Payment Accounting',
  'FAQ',
  'Payment Transactions',
  'Patient Package',
  'Push Notification',
  'Bank Info',
  'Doctor Shcedule',
  'Doctor Slots',
  'Create Slot',
  'Active Doctor',
  'Emergency Doctors',
  'Emergency Patients',
  'Emergency Card',
  'Se7etak Stats',
  'Covid Medications',
  'Doctor Specialities',
  'Cities',
  'Scan Requests',
  'Examination Requests',
  'Labs',
  'Test Requests',
  'PSP Programs',
  'PSP Subscriptions',
  'PatientDetailsByPhone',
  'Services',
  'Psp Medication Requests',
  'Erp Pharmacies',
  'PspEva',
  'PspLilly',
  'PspRoche'
];

export const PspEvaPermission = 'PspEva';
export const PspLillyPermission = 'PspLilly';
export const PspRochePermission = 'PspRoche';
